module.exports = __webpack_public_path__ + "static/media/opinion.ed8128b9.svg";